import { useCallback } from "react";
import type { PublicSetting } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchPublicSettings = (): UseFetchActionReturn<PublicSetting> => {
    const fetchPublicSettings = useCallback(() => {
        return store.publicSettingsApi.publicSettingsReadPublicSetting();
    }, []);
    return useFetchAction(fetchPublicSettings);
};
